import { useCheckoutContext } from '@pages/Checkout/routes/contexts'
import { PAYMENTS } from '@routes/path'
import { Button } from '@ui-kit'

export const Configure = () => {
  const { goToStep } = useCheckoutContext()

  return (
    <div>
      <h1>Configure</h1>

      {/* //TODO - delete this */}
      <span>
        <Button onClick={() => goToStep(PAYMENTS.CHECKOUT.PAYMENT)}>
          Next route
        </Button>
      </span>
    </div>
  )
}

Configure.displayName = 'CheckoutConfigure'
